module.exports = __webpack_public_path__ + "413ba30b36f497e47aa8df1d12cf6740.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/adventure-tube-blue-s.png
// module id = 1837
// module chunks = 0